import { api } from '@/lib/axios';

export interface AdminRestaurantAccess {
  id: string;
  name: string;
}

export interface AdminRestaurantAccessResponse {
  restaurants: AdminRestaurantAccess[];
  selected_restaurant_id: string | null;
}

export const adminRestaurantAccessService = {
  async list(): Promise<AdminRestaurantAccessResponse> {
    const response = await api.get<AdminRestaurantAccessResponse>('/v1/admin/restaurant_accesses');
    return response.data;
  },

  async select(restaurantId: string) {
    const response = await api.patch('/v1/admin/restaurant_accesses/select', {
      restaurant_id: restaurantId,
    });

    return response.data;
  },
};
